<template>
  <div class="page-content main-content wide">
    <div class="header">
      <div class="wrap">
        <div class="header-logo-wrap">
          <a href="/">
            <span>airBaltic</span>
            <img
              src="~assets/images/airbaltic.svg"
              alt="airBaltic"
              width="120"
              height="29"
            >
          </a>
        </div>
        <h1 v-if="!isMobile">{{ pageData.pageTitle }}</h1>
      </div>
    </div>

    <div class="wrap">
      <h1 v-if="isMobile">{{ pageData.pageTitle }}</h1>
      <div
        v-if="pageData.description"
        v-dompurify-html="pageData.description"
        class="description"
      />

      <fare-conditions-table
        :tables="pageData.tables"
        :columns="pageData.tableHeader"
      />

      <div
        v-if="pageData.bottomContent"
        v-dompurify-html="pageData.bottomContent"
        class="bottom-content"
      />
    </div>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import FareConditionsTable from 'components/Tables/FareConditionsTable'

  export default {
    components: {
      FareConditionsTable
    },

    computed: {
      ...mapGetters('device', [
        'isMobile'
      ]),

      ...mapState('fareConditions', [
        'pageData'
      ])
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  h1 {
    margin: 0;
    padding: 26px 24px 28px;
    font-size: em(32);
    font-weight: 300;

    @include bp-mf-tablet {
      float: right;
      font-size: em(40);
      padding: 30px 24px;
    }

    @include bp-mf-desktop {
      padding-right: 0;
    }
  }

  .description {
    font-size: em(18);
    font-weight: 200;
    line-height: 24px;
    margin: 0 24px 18px;

    @include bp-mf-tablet {
      font-size: em(20);
      line-height: 32px;
    }

    @include bp-mf-desktop {
      font-size: em(20);
      line-height: 32px;
      margin: 0 0 18px;
    }

    /deep/ a {
      color: $blue-medium;
      text-decoration: underline;
    }
  }

  .header {
    @include clearfix();
    border-bottom: 1px solid $grey-border;
  }

  .header-logo-wrap {
    width: 126px;
    height: 60px;
    background-color: $green-base;
    font-size: 0;
    line-height: 0;
    float: right;

    @include bp-mf-tablet {
      width: 180px;
      height: 110px;
      float: left;
    }

    a {
      display: block;
      height: 100%;
    }

    img {
      display: block;
      position: relative;
      top: 21px;
      width: auto;
      height: 18px;
      margin: 0 auto;
      transition: all .3s linear;
      pointer-events: none;

      @include bp-mf-tablet {
        top: 41px;
        height: 29px;
        width: 120px;
      }
    }
  }

  .bottom-content {
    padding: 28px 20px 14px;
    margin-top: 24px;
    background-color: $white-dropdown-header;
    border-left: 4px solid #e7e7e7;
    font-size: em(12);

    @include bp-mf-tablet {
      padding-left: 28px;
      margin-bottom: 24px;
    }

    /deep/ {

      p {
        margin: 0;
      }

      a {
        color: $blue-medium;

        &:hover {
          color: $blue-light;
        }
      }

      ul {
        list-style: none;
      }

      li {
        counter-increment: list-items;
        margin-bottom: 15px;
        line-height: 18px;

        &:before {
          content: counter(list-items) " ";
          color: $blue-medium;
          font-weight: 500;
        }
      }
    }
  }

</style>
